import {Component, Input, OnInit} from '@angular/core';
import {CountPipe} from '../../../../../shared/pipes/count.pipe';
import {SizePipe} from '../../../../../shared/pipes/size.pipe';

@Component({
    selector: 'db-trial-plan-sidebar',
    templateUrl: './trial-plan-sidebar.component.html',
    styleUrl: './trial-plan-sidebar.component.scss',
    standalone: false
})
export class TrialPlanSidebarComponent implements OnInit {

  constructor(
    private countPipe: CountPipe,
    private sizePipe: SizePipe
  ) {}
  @Input() freeDaysCount!: number;
  @Input() subscription: any;

  benefits = [
    {
      id: 1,
      title: '{{websiteCount}} website'
    },
    {
      id: 6,
      title: 'Intuitive drag & drop website editor'
    },
    {
      id: 7,
      title: 'Premium cloud hosting: 99.9% uptime'
    },
    {
      id: 8,
      title: '90+ PageSpeed score'
    },
  ];

  ngOnInit() {
    const websiteCount = this.subscription?.plan?.hostingService?.domain_count?.parameter_value;

    for (let i = 0; i < this.benefits.length; i++) {
      this.benefits[i].title = this.benefits[i].title
        .replace("{{websiteCount}}", websiteCount);
    }
  }
}
